import { connect } from "react-redux";
import Invoices from '../components/settings/Invoices';
import { fetchList } from "../store/actions/invoices";
import withAuth from '../hocs/withAuth';

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    invoices: state.invoices
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetch: (userId) => {
      return dispatch(fetchList(userId));
    }
  }
}

export const MyInvoices = withAuth(connect(mapStateToProps, mapDispatchToProps)(Invoices));



// WEBPACK FOOTER //
// ./src/containers/MyInvoices.js